import React from "react";
import { GATSBY_MOBILE_APP } from "../../../@types/Constants";
import { Spinner } from "react-bootstrap";

const ClientOnly = ({
  children,
  ...delegated
}: {
  children: JSX.Element | JSX.Element[];
}) => {
  const [hasMounted, setHasMounted] = React.useState(false);
  React.useEffect(() => {
    setHasMounted(true);
  }, []);
  if (!GATSBY_MOBILE_APP) {
    return <div {...delegated}>{children}</div>;
  }
  if (!hasMounted) {
    return (
      <div
        style={{
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <Spinner animation={"border"} />
      </div>
    );
  }
  return <div {...delegated}>{children}</div>;
};

export default ClientOnly;
